import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Value = styled.div`
  height: 24px;
  line-height: 24px;
  background: rgba(240, 185, 11, 0.15);
  border-radius: 3px;
  padding: 0 5px;
  color: #f0b90b;
  text-align: center;
  max-width: 60px;
`

const TotalValue = styled(Value)`
  background: rgba(0, 192, 135, 0.15);
  color: #00c087;
`

const CanceledValue = styled(Value)`
  background: rgba(149, 158, 177, 0.15);
  color: #959eb1;
`

class Filled extends PureComponent {
  static propTypes = {
    value: PropTypes.number,
    status: PropTypes.string,
  }

  static defaultProps = {
    value: 0,
    status: '',
  }

  render() {
    let { value } = this.props
    const { status } = this.props
    value = value || 0
    return (
      <div>
        {status !== 'Canceled' && value === 100 && (
          <TotalValue>{`${value.toFixed(2)}%`}</TotalValue>
        )}

        {status !== 'Canceled' && value >= 0 && value < 100 && (
          <Value>{`${value.toFixed(2)}%`}</Value>
        )}

        {status === 'Canceled' && <CanceledValue>{`${value.toFixed(2)}%`}</CanceledValue>}
      </div>
    )
  }
}

export default Filled
